import React from "react";
import ManufacturedDevices from "../../device/ManufacturedDevices";

const ManufacturedDevicesPage = () => {
  return (
    <div className="right-content-wraper">
      <ManufacturedDevices />
    </div>
  );
};

export default ManufacturedDevicesPage;
